import React, { useMemo } from 'react';
import { AgreementStateActionType, useAgreementContext } from './index';
import { useIntl } from 'react-intl';
import Checkbox from '../../components/input/checkbox';
import translations from './agreementpermits.i18n';

const AgreementPermits = () => {
  const { delIdentitetsnummer, dispatchAgreementEdit, canEditAgreement } =
    useAgreementContext();
  const { formatMessage } = useIntl();
  const labels = useMemo(
    () => ({
      sharePersonnummerCheckbox: formatMessage({
        id: translations.sharePersonnummerCheckbox.id,
      }),
    }),
    [formatMessage],
  );

  const setSharePersonnummer = (checked: boolean) =>
    dispatchAgreementEdit({
      type: AgreementStateActionType.SET_SHARE_PERSONNUMMER,
      payload: checked,
    });

  return (
    <Checkbox
      id={'sharePersonnummer'}
      label={labels.sharePersonnummerCheckbox}
      checked={delIdentitetsnummer}
      setChecked={setSharePersonnummer}
      disabled={!canEditAgreement}
    />
  );
};

export default AgreementPermits;
